module.exports = __webpack_public_path__ + "quilt2-level6.30fb78a4.png";